module.exports = __webpack_public_path__ + "img/Support-skill-516.0c37b3af.png";